"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorDropdownBody = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var OperatorDropdownItem_1 = require("./OperatorDropdownItem");
var OperatorDropdownBodyComponent = function (_a) {
    var items = _a.items, selectedValue = _a.selectedValue, onSelect = _a.onSelect, onClose = _a.onClose, intl = _a.intl;
    return (react_1.default.createElement(sdk_ui_kit_1.Overlay, { closeOnOutsideClick: true, alignTo: ".gd-rf-operator-dropdown-button", alignPoints: [{ align: "bl tl" }, { align: "tl bl" }], onClose: onClose },
        react_1.default.createElement("div", { className: "gd-dropdown overlay gd-rf-inner-overlay-dropdown gd-rf-operator-dropdown-body s-rf-operator-dropdown-body" }, items.map(function (_a) {
            var value = _a.value, translationId = _a.translationId;
            var title = intl.formatMessage({ id: translationId });
            return (react_1.default.createElement(OperatorDropdownItem_1.OperatorDropdownItem, { key: value, title: title, value: value, isSelected: value === selectedValue, onSelect: onSelect }));
        }))));
};
exports.OperatorDropdownBody = react_intl_1.injectIntl(OperatorDropdownBodyComponent);
//# sourceMappingURL=OperatorDropdownBody.js.map